const MATERIALS = 'Materials';
const TOOLS = 'Tools';
const PS_CONTENT = 'Here are the materials and tools you might need to tackle this project.';
const PRODUCT_ASSORTMENT = {
  CONTENT: 'Some informational content designed to help guide customer',
  ERROR: {
    get CONTENT() { return PRODUCT_ASSORTMENT.CONTENT; },
    BUTTON_TEXT: 'Refresh',
    SECONDARY_TEXT: 'and try again',
    TITLE: 'We are unable to load products.',
    TYPE: 'information'
  },
  MAX_ATTEMPTS_TEXT: 'Max number of refetch attempts reached. Try again later',
  REFETCH_ALLOWANCE: 1
};

// EVENT NAMES
const REFRESH_CART = 'ps.refresh-cart-total';

export {
  MATERIALS,
  PRODUCT_ASSORTMENT,
  PS_CONTENT,
  REFRESH_CART,
  TOOLS
};